import { createContext } from 'react';

const defaultValue = {
  isReady: true,
  viewportWidth: 0,
  breakpoint: "xs",
  responsiveBreakpoints: ["xs"],
  contentWidth: 0,
  setContentWidth: () => {
  },
  isAsideMenuOpen: false,
  setIsAsideMenuOpen: () => {
  },
  isRightMenuOpen: false,
  isRightMenuReadyToHide: true,
  setIsRightMenuReadyToHide: () => {
  },
  setIsRightMenuOpen: () => {
  },
  isModalMenuOpen: false,
  setIsModalMenuOpen: () => {
  },
  menuExpandedLinkCollection: null,
  setMenuExpandedLinkCollection: () => {
  }
};
const LayoutCtx = createContext(defaultValue);

export { LayoutCtx };
//# sourceMappingURL=context.js.map
